import React from 'react';
import { useLocation } from 'react-router-dom';
import {Banner} from '../src/components/Banner';
import {Footer} from '../src/components/Footer';
import { ReworthDirectory } from '@reworthrewards/directory-react-component';

const App = () => {
  const location = useLocation();
  const fiid = process.env.REACT_APP_FIID ?? "";
  const isRewardsPage = location.pathname === '/rewards';
  return (
    <div>
    {!isRewardsPage && <Banner />}
      <ReworthDirectory
        accentColor='#FF5F54'
        env='prod'
        skin='FINSUS'
        fiid={fiid}
        fontFamily='Poppins'
        gtm
      />
      < Footer />
    </div>
  )
}

export default App
